
export interface Wrsv {
    id: string;
    wellStringId: string;
    wellLongName: string;
    fieldLongName: string;
    platformLongName: string;
    stringShortName: string;
    stringLongName: string;
    wellProductionStatus: string;
    latestInstalledDate: string;
    installationDueDate: string;
    installationAdditionalDueDate: string;
    planDate: string;
    daysOverdue: number;
    daysSinceLastInstallation: number;
    installationStatus: string;
    remark: string;
    inputDate: string;
    wrsvType: string;
}